import { render, staticRenderFns } from "./ModalCalculation.vue?vue&type=template&id=01bf2c22&scoped=true"
import script from "./ModalCalculation.vue?vue&type=script&lang=js"
export * from "./ModalCalculation.vue?vue&type=script&lang=js"
import style0 from "./ModalCalculation.vue?vue&type=style&index=0&id=01bf2c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bf2c22",
  null
  
)

export default component.exports